// extracted by mini-css-extract-plugin
export default {"root":"styles_root__barrl","logo":"styles_logo__zI9He","blink":"styles_blink__ZRKy2"};